<template>
  <PdfViewerCaptureOverlay
    v-if="pdfCaptureStore.activeCapture"
    :pdf-url="pdfCaptureStore.activeCapture.pdfUrl"
    :pdf-filename="pdfCaptureStore.activeCapture.pdfFilename"
    :media-object-uuid="pdfCaptureStore.activeCapture.mediaObjectUuid"
    :resource-type="pdfCaptureStore.activeCapture.resourceType"
    :resource-id="pdfCaptureStore.activeCapture.resourceId"
    :current-kb-count="pdfCaptureStore.activeCapture.currentKbCount"
    :max-kb-allowed="pdfCaptureStore.activeCapture.maxKbAllowed"
    :rich-text-context="pdfCaptureStore.activeCapture.richTextContext"
    @close="pdfCaptureStore.close()"
    @image-saved="onImageSaved"
  />
</template>

<script setup lang="ts">
import { usePdfCaptureStore } from "@plugins/authoring-copilot/pdf-capture.store.ts";
import PdfViewerCaptureOverlay from "@plugins/pdf-viewer/components/PdfViewerCaptureOverlay.vue";

const pdfCaptureStore = usePdfCaptureStore();

const onImageSaved = (kbEntry: unknown) => {
  pdfCaptureStore.activeCapture?.onImageSaved?.(kbEntry);
  // Keep currentKbCount in sync so isMaxKbReached stays accurate for subsequent captures
  if (pdfCaptureStore.activeCapture) {
    pdfCaptureStore.activeCapture.currentKbCount =
      (pdfCaptureStore.activeCapture.currentKbCount ?? 0) + 1;
  }
  // Do NOT close after image-saved — user may want to capture more pages
};
</script>
